module.exports = __webpack_public_path__ + "static/media/andrew-reduced.de7dac90.jpg";